import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { SALES_ORDER_ITEM_BREAKDOWN, } from '../types/sales-order-item-breakdown.js';
/**
 * Descriptor for SalesOrderItemBreakdown (size rows under an order line).
 * Subcollection: org/{orgId}/sales-order/{salesOrderId}/item/{itemId}/breakdown
 *
 * Resolve repository with context: { orgId, salesOrderId, itemId }.
 */
export const salesOrderItemBreakdownDescriptor = {
    name: SALES_ORDER_ITEM_BREAKDOWN,
    label: 'Breakdown do item do pedido',
    domain: 'sales',
    collectionPath: 'org/{orgId}/sales-order/{salesOrderId}/item/{itemId}/breakdown',
    pathPatternKeys: {
        orgId: 'string',
        salesOrderId: 'string',
        itemId: 'string',
    },
    version: 1,
    description: 'Size distribution of an order line — full ProductVariant per size (spec 0031 §4.5)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'salesOrderItemId',
            label: 'Item do pedido',
            type: 'string',
            required: true,
            description: 'Parent order line id (also encoded in the path)',
        },
        {
            name: 'variantId',
            label: 'Variante',
            type: 'string',
            required: true,
            description: 'Full ProductVariant (includes size)',
        },
        {
            name: 'quantity',
            label: 'Quantidade',
            type: 'number',
            display: 'quantity',
            required: true,
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Variante completa (com tamanho)',
        },
        {
            fieldName: 'salesOrderItemId',
            targetEntity: 'SalesOrderItem',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Item de pedido pai',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=sales-order-item-breakdown.descriptor.js.map